import { Component, ViewChild, OnInit } from '@angular/core';
import { UserService } from 'src/app/data/user/user.service';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../../environments/environment';
import { AuthService } from 'src/app/auth/auth.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  appName = environment.appName;
  username: string;
  knowledgeToolTip = 'Kinergy Knowledge Assistant';


  @ViewChild('settingsTrigger') settingsTrigger!: MatMenuTrigger;
  @ViewChild('userProfileTrigger') userProfileTrigger!: MatMenuTrigger;

  constructor(public userService: UserService, private authService: AuthService,  private dialog: MatDialog){}

  openLink(): void {
    window.open('https://m365.cloud.microsoft/chat/?titleId=T_0b3232ce-bde9-d142-4244-ca68192d9aa6&auth=2');
  }

  ngOnInit(): void {
    this.username = this.authService.getLoggedUsername();
  }

  onLogout(): void {
    this.authService.signOut();
  }


  closeAllMenusApartSetting(): void {
    this.userProfileTrigger?.closeMenu();
     this.dialog.closeAll();
  }

  closeAllMenuApartProfile(): void {
    this.settingsTrigger?.closeMenu();
     this.dialog.closeAll();
  }

}
